import { FolderIcon } from "@/Icons/v2/Library/FolderIcon";
import { LibraryPageContext } from "@/pages/library_v2/components/filesView/context";
import {
  FILE_STATUS_PARAMS,
  FileStatus,
} from "@/pages/library_v2/components/filesView/types";
import { useTrans } from "@/translations";

import { useCallback, useContext, useMemo } from "react";

import { twMerge } from "tailwind-merge";

type Props = {
  value: FileStatus;
};

export const MainFolderView: React.FC<Props> = ({ value }) => {
  const { t } = useTrans();
  const {
    selectedViewId,
    setSelectedViewId,
    setSelectedFolderName,
    setSearchValue,
  } = useContext(LibraryPageContext);

  const isSelected = useMemo(
    () => selectedViewId === value,
    [selectedViewId, value],
  );

  const updateSelectedView = useCallback(() => {
    setSelectedViewId(value);
    setSearchValue("");
    setSelectedFolderName("");
  }, [setSelectedViewId, value, setSelectedFolderName, setSearchValue]);

  return (
    <button
      type="button"
      onClick={updateSelectedView}
      className={twMerge(
        "flex w-full cursor-pointer items-center gap-[9px] rounded-[7px] px-[9px] py-2 text-left text-[13px] font-semibold text-[#1D1C1C]",
        isSelected ? "bg-[#F3F5AE]" : "hover:bg-grey1 bg-transparent",
      )}
    >
      <FolderIcon size={14} color={isSelected ? "#1D1C1C" : "#6F6C6C"} />
      <span className="min-w-0 flex-1">
        {t(FILE_STATUS_PARAMS[value].folderNameKey)}
      </span>
    </button>
  );
};
